import {serviceUpload} from "@/services/uploadimage.service";


const state = {
    loadingupload: false,
    defaultimg:'',
}
const actions = {
    resetimage({commit}){
        commit('resetimage');
    },
    uploadImage({ dispatch, commit },imgfile){
        commit('setloading', true);
        serviceUpload.uploadimage(imgfile)
            .then(response => {
                dispatch('alert/success', 'image ready...', { root: true });
                commit('setloading', false);
                commit('doneupload', response);
            })
            .catch(error => {
                console.log(error)
            })
    },
}
const mutations = {
    resetimage(state){
        state.defaultimg="";
    },
    setloading (state, sload) {
        state.loadingupload = sload
    },
    doneupload(state,data){
        state.loadingupload=false;
        state.defaultimg=data.imageurl;
    },
}


export const UploadImage = {
    namespaced: true,
    state,
    actions,
    mutations
};
